// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Sk-z","modalContent":"Tk-z","header":"Uk-z","close":"Vk-z"};